<template>
  <div class="activity-stream-box" id="activityShow">
    <div class="activity-stream-box-in">
      <div class="activity-stream-box-top">
        <h2>
          {{ constants.ACTIVITY_STREAM_TEXT }}
        </h2>
       <div class="calendar-drop-down-box" :class="{ 'show-calendar-dropdown': isCalendarOpen }">
          <div class="calendar-drop-down-icon" @click="isCalendarOpen = !isCalendarOpen">
            <img src="@/assets/lems-v1/images/calendar.svg" alt="" />
          </div>
          <div class="calendar-drop-down-content">
            <div class="calendar-drop-down-content-inner">
              <div class="choose-calendar">
                <DatePicker v-model="selectedDate" inline @update:modelValue="validateDate" :max-date="new Date()" />
              </div>
              <div class="custom-filter">
                <button id="allCalendarBtn" @click="setDateFilter('all')" :class="{ active: selectedDateFilter === 'all' }">All</button>
                <button id="lastWeekCalendarBtn" @click="setDateFilter('last_week')" :class="{ active: selectedDateFilter === 'last_week' }">Last Week</button>
                <button id="lastMonthCalendarBtn" @click="setDateFilter('last_month')" :class="{ active: selectedDateFilter === 'last_month' }">Last Month</button>
                <button id="lastYearCalendarBtn" @click="setDateFilter('last_year')" :class="{ active: selectedDateFilter === 'last_year' }">Last Year</button>
              </div>
            </div>
          </div>
        </div>
        <button id="activityFullbtn" class="view-full-size">
          <img src="@/assets/lems-v1/images/full-size.svg" alt="" />
        </button>
        <button id="activityClosebtn" class="view-close-size">
          <img src="@/assets/lems-v1/images/close-black-icon.svg" alt="" />
        </button>
      </div>
      <div class="activity-stream-list">
        <div v-if="loading" class="loading-data-text">
          <p>Loading activity...</p>
        </div>
        <template v-else>
          <div class="activity-long" v-if="groupedActivities.today.length">
            <span>
              {{ constants.TODAY_TEXT }}
            </span>
          </div>
          <div class="activity-stream-details" v-if="groupedActivities.today.length">
            <div class="activity-stream-row" v-for="activity in groupedActivities.today" :key="activity.id">
            <span>
                <div class="user-status user-status-active"></div>
                <img v-if="activity.userAvatar" :src="activity.userAvatar" alt="" />
            </span>
            <div class="activity-stream-text">
              <div class="activity-stream-rept">
                <h5>
                    {{ activity.userDisplayName || 'Unknown' }}
                    <i>updated</i>
                    <a href="#">{{ activity.issueKey }} - {{ activity.summary }}</a>
                </h5>
                <div class="activity-stream-ul">
                  <ul>
                    <li>
                        <i><img src="@/assets/lems-v1/images/viewavatar.svg" alt="" /></i>
                        {{ activity.agoValue }}
                        {{ activity.agoUnit === 'min' ? constants.PLURAL_MIN_TEXT : constants.PLURAL_HR_TEXT }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

          <div class="activity-long" v-if="groupedActivities.yesterday.length">
          <span>
            {{ constants.YESTERDAY_TEXT }}
          </span>
        </div>
          <div class="activity-stream-details" v-if="groupedActivities.yesterday.length">
            <div class="activity-stream-row" v-for="activity in groupedActivities.yesterday" :key="activity.id">
            <span>
                <div class="user-status user-status-active"></div>
                <img v-if="activity.userAvatar" :src="activity.userAvatar" alt="" />
            </span>
            <div class="activity-stream-text">
              <div class="activity-stream-rept">
                <h5>
                    {{ activity.userDisplayName || 'Unknown' }}
                    <i>updated</i>
                    <a href="#">{{ activity.issueKey }} - {{ activity.summary }}</a>
                </h5>
                <div class="activity-stream-ul">
                  <ul>
                    <li>
                        <i><img src="@/assets/lems-v1/images/viewavatar.svg" alt="" /></i>
                        {{ activity.agoValue }}
                        {{ activity.agoUnit === 'min' ? constants.PLURAL_MIN_TEXT : constants.PLURAL_HR_TEXT }}
                    </li>
                  </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="activity-long" v-if="groupedActivities.earlier.length">
            <span>
              Earlier
            </span>
          </div>
          <div class="activity-stream-details" v-if="groupedActivities.earlier.length">
            <div class="activity-stream-row" v-for="activity in groupedActivities.earlier" :key="activity.id">
            <span>
              <div class="user-status user-status-active"></div>
                <img v-if="activity.userAvatar" :src="activity.userAvatar" alt="" />
            </span>
            <div class="activity-stream-text">
              <div class="activity-stream-rept">
                <h5>
                    {{ activity.userDisplayName || 'Unknown' }}
                    <i>updated</i>
                    <a href="#">{{ activity.issueKey }} - {{ activity.summary }}</a>
                </h5>
                <div class="activity-stream-ul">
                  <ul>
                    <li>
                        <i><img src="@/assets/lems-v1/images/viewavatar.svg" alt="" /></i>
                        {{ activity.agoValue }}
                        {{ activity.agoUnit === 'min' ? constants.PLURAL_MIN_TEXT : constants.PLURAL_HR_TEXT }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        </template>
      </div>
      <div class="pagination-box" v-if="totalPages > 1">
        <ul>
          <li
            class="pagination-first"
            v-if="currentPage !== 1"
            @click="changePage(currentPage - 1)"
          >
            <button id="paginationPreButton"></button>
          </li>
          <li
            v-for="page in visiblePages"
            :key="page"
            @click="changePage(page)"
          >
            <a href="#" :class="{ active: currentPage === page }">{{ page }}</a>
          </li>
          <li
            class="pagination-last"
            v-if="currentPage !== totalPages"
            @click="changePage(currentPage + 1)"
          >
            <button id="paginationNextButton"></button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import constants from "@/utils/en-US-Employee.json";
import axios from "axios";
import { API_BASE_URL } from "@/config/api.config";
import { DatePicker } from 'v-calendar';
import 'v-calendar/style.css';
import moment from "moment";

interface JiraUserRef {
  displayName?: string;
  avatarUrls?: { [key: string]: string };
}

interface IssueFields {
  summary: string;
  issuetype?: { iconUrl?: string };
  status?: { name?: string };
  assignee?: JiraUserRef | null;
  reporter?: JiraUserRef | null;
  created?: string;
  updated?: string;
}

interface Issue {
  id: string;
  key: string;
  fields: IssueFields;
}

interface ActivityItem {
  id: string;
  issueKey: string;
  summary: string;
  updated: string;
  userDisplayName: string | null;
  userAvatar: string | null;
  agoValue: number;
  agoUnit: 'min' | 'hr';
}

export default defineComponent({
  name: "Activity",
  data() {
    return {
      constants,
      issues: [] as Issue[],
      loading: false,
      selectedDateFilter: 'all' as 'all' | 'last_week' | 'last_month' | 'last_year' | 'custom_date',
      currentPage: 1,
      totalPages: 0,
      limit: 10,
      start: 0,
      isProjectDetailsMode: false,
      selectedDate: null as Date | null,
      isCalendarOpen: false,
    };
  },
  components: {
    DatePicker,
  },
  computed: {
    activityItems(): ActivityItem[] {
      const now = new Date();
      return this.issues.map((issue: Issue) => {
        const updatedStr = issue.fields.updated || issue.fields.created || new Date().toISOString();
        const updatedDate = new Date(updatedStr);
        const diffMs = now.getTime() - updatedDate.getTime();
        const diffMin = Math.max(1, Math.floor(diffMs / (1000 * 60)));
        const agoUnit: 'min' | 'hr' = diffMin < 60 ? 'min' : 'hr';
        const agoValue = agoUnit === 'min' ? diffMin : Math.max(1, Math.floor(diffMin / 60));

        const assignee = issue.fields.assignee || issue.fields.reporter || {};
        const avatar = (assignee.avatarUrls && (assignee.avatarUrls['48x48'] || assignee.avatarUrls['24x24'])) || null;

        return {
          id: issue.id,
          issueKey: issue.key,
          summary: issue.fields.summary,
          updated: updatedStr,
          userDisplayName: assignee.displayName || null,
          userAvatar: avatar,
          agoValue,
          agoUnit,
        };
      });
    },
    groupedActivities(): { today: ActivityItem[]; yesterday: ActivityItem[]; earlier: ActivityItem[] } {
      const today: ActivityItem[] = [];
      const yesterday: ActivityItem[] = [];
      const earlier: ActivityItem[] = [];

      const now = new Date();
      const todayStr = now.toDateString();
      const yest = new Date(now);
      yest.setDate(now.getDate() - 1);
      const yestStr = yest.toDateString();

      for (const a of this.activityItems) {
        const d = new Date(a.updated);
        const dStr = d.toDateString();
        if (dStr === todayStr) {
          today.push(a);
        } else if (dStr === yestStr) {
          yesterday.push(a);
        } else {
          earlier.push(a);
        }
      }

      return { today, yesterday, earlier };
    },
    visiblePages(): number[] {
      const maxVisiblePages = 5;
      const half = Math.floor(maxVisiblePages / 2);
      let start = Math.max(this.currentPage - half, 1);
      let end = start + maxVisiblePages - 1;
      if (end > this.totalPages) {
        end = this.totalPages;
        start = Math.max(end - maxVisiblePages + 1, 1);
      }
      return Array.from({ length: Math.max(0, end - start + 1) }, (_, i) => start + i);
    },
  },
  mounted() {
    // Check if we're in project details mode
    this.isProjectDetailsMode = this.$route.name === 'project-detail';
    this.getActivities();
  },
  methods: {
    async getActivities() {
      const username = localStorage.getItem("jira_user_username");
      if (!username) return;
      this.loading = true;
      try {
        const params = new URLSearchParams({
          start: this.start.toString(),
          limit: this.limit.toString(),
          filter: 'updated_recently',
          date_filter: this.selectedDateFilter,
        });

        // Add project filter if in project details mode
        if (this.isProjectDetailsMode && this.$route.params.projectKey) {
          params.append('project', this.$route.params.projectKey as string);
        }

        if (this.selectedDateFilter === "custom_date" && this.selectedDate) {
          params.append('custom_date', moment(this.selectedDate).format("YYYY-MM-DD"));
        }

        const response = await axios.get(
          `${API_BASE_URL}/jira/issues/${username}/?${params.toString()}`
        );
        this.issues = response.data.issues || [];
        this.totalPages = response.data.total_pages || 0;
      } catch (error) {
        console.error("Error fetching activity:", error);
        this.issues = [];
        this.totalPages = 0;
      } finally {
        this.loading = false;
      }
    },
    setDateFilter(filter: 'all' | 'last_week' | 'last_month' | 'last_year' | 'custom_date') {
      this.selectedDateFilter = filter;
      this.currentPage = 1;
      this.start = 0;
      this.getActivities();
    },
    changePage(page: number) {
      if (page > 0 && page <= this.totalPages) {
        this.currentPage = page;
        this.start = (page - 1) * this.limit;
        this.getActivities();
      }
    },
    validateDate(date: Date) {
      if (date) {
        this.isCalendarOpen = false;
        this.selectedDateFilter = "custom_date";
        this.selectedDate = date;
        this.setDateFilter('custom_date');
      }
      else {
        this.isCalendarOpen = false;
        this.selectedDate = null;
        this.setDateFilter('all'); 
      }
    },
    closeCalendar() {
      this.isCalendarOpen = false;
    },
  },
  watch: {
    // Watch for changes in the route parameter
    '$route.params.projectKey': {
      handler(newKey, oldKey) {
        if (newKey !== oldKey && newKey && this.isProjectDetailsMode) {
          this.currentPage = 1;
          this.start = 0;
          this.getActivities();
        }
      },
      immediate: false
    }
  }
});
</script>
